(window["webpackJsonpmeg_ui"] = window["webpackJsonpmeg_ui"] || []).push([["index~menu"],{

/***/ 155:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "MenuMode", function() { return /* binding */ MenuMode; });
__webpack_require__.d(__webpack_exports__, "menuProps", function() { return /* binding */ menu_menuProps; });

// EXTERNAL MODULE: ./node_modules/babel-helper-vue-jsx-merge-props/index.js
var babel_helper_vue_jsx_merge_props = __webpack_require__(3);
var babel_helper_vue_jsx_merge_props_default = /*#__PURE__*/__webpack_require__.n(babel_helper_vue_jsx_merge_props);

// EXTERNAL MODULE: ./node_modules/omit.js/es/index.js
var es = __webpack_require__(13);

// EXTERNAL MODULE: ./src/base/vc-menu/index.js + 10 modules
var vc_menu = __webpack_require__(17);

// EXTERNAL MODULE: ./src/utils/props_util.js
var props_util = __webpack_require__(1);

// EXTERNAL MODULE: external "classnames"
var external_classnames_ = __webpack_require__(2);
var external_classnames_default = /*#__PURE__*/__webpack_require__.n(external_classnames_);

// CONCATENATED MODULE: ./src/components/menu/SubMenu.jsx
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ var SubMenu = ({
  name: "MegSubMenu",
  isSubMenu: true,
  props: _objectSpread({}, vc_menu["d" /* SubMenu */].props),
  inject: {
    menuPropsContext: {
      default: function _default() {
        return {};
      }
    }
  },
  methods: {
    onKeyDown: function onKeyDown(e) {
      this.$refs.subMenu.onKeyDown(e);
    }
  },
  render: function render() {
    var h = arguments[0];
    var $slots = this.$slots,
        $scopedSlots = this.$scopedSlots;
    var _this$$props = this.$props,
        rootPrefixCls = _this$$props.rootPrefixCls,
        popupClassName = _this$$props.popupClassName;
    var antdMenuTheme = this.menuPropsContext.theme;
    var props = {
      props: _objectSpread(_objectSpread({}, this.$props), {}, {
        popupClassName: external_classnames_default()("".concat(rootPrefixCls, "-").concat(antdMenuTheme), popupClassName)
      }),
      ref: "subMenu",
      on: Object(props_util["getListeners"])(this),
      scopedSlots: $scopedSlots
    };
    var slotsKey = Object.keys($slots);
    return h(vc_menu["d" /* SubMenu */], props, [slotsKey.length ? slotsKey.map(function (name) {
      return h("template", {
        slot: name
      }, [$slots[name]]);
    }) : null]);
  }
});
// EXTERNAL MODULE: ./src/utils/vue_types/index.js + 1 modules
var vue_types = __webpack_require__(0);

// EXTERNAL MODULE: ./src/utils/openAnimation.js
var utils_openAnimation = __webpack_require__(102);

// EXTERNAL MODULE: ./src/utils/warning.js + 1 modules
var warning = __webpack_require__(12);

// EXTERNAL MODULE: ./src/components/tooltip/index.jsx + 6 modules
var tooltip = __webpack_require__(34);

// CONCATENATED MODULE: ./src/components/menu/MenuItem.jsx


function MenuItem_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function MenuItem_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { MenuItem_ownKeys(Object(source), true).forEach(function (key) { MenuItem_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { MenuItem_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function MenuItem_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





function noop() {}

/* harmony default export */ var MenuItem = ({
  name: "MegMenuItem",
  inheritAttrs: false,
  props: vc_menu["f" /* itemProps */],
  inject: {
    getInlineCollapsed: {
      default: function _default() {
        return noop;
      }
    },
    layoutSiderContext: {
      default: function _default() {
        return {};
      }
    }
  },
  isMenuItem: true,
  methods: {
    onKeyDown: function onKeyDown(e) {
      this.$refs.menuItem.onKeyDown(e);
    }
  },
  render: function render() {
    var h = arguments[0];
    var props = Object(props_util["getOptionProps"])(this);
    var level = props.level,
        title = props.title,
        rootPrefixCls = props.rootPrefixCls;
    var getInlineCollapsed = this.getInlineCollapsed,
        $slots = this.$slots,
        attrs = this.$attrs;
    var inlineCollapsed = getInlineCollapsed();
    var tooltipProps = {
      title: title || (level === 1 ? $slots.default : "")
    };
    var siderCollapsed = this.layoutSiderContext.sCollapsed;

    if (!siderCollapsed && !inlineCollapsed) {
      tooltipProps.title = null;
      tooltipProps.visible = false;
    }

    var itemProps = {
      props: MenuItem_objectSpread(MenuItem_objectSpread({}, props), {}, {
        title: title
      }),
      attrs: attrs,
      on: Object(props_util["getListeners"])(this)
    };
    var toolTipProps = {
      props: MenuItem_objectSpread(MenuItem_objectSpread({}, tooltipProps), {}, {
        placement: "right",
        overlayClassName: "".concat(rootPrefixCls, "-inline-collapsed-tooltip")
      })
    };
    return h(tooltip["default"], toolTipProps, [h(vc_menu["b" /* Item */], babel_helper_vue_jsx_merge_props_default()([itemProps, {
      ref: "menuItem"
    }]), [$slots.default])]);
  }
});
// EXTERNAL MODULE: ./src/utils/BaseMixin.js
var BaseMixin = __webpack_require__(4);

// EXTERNAL MODULE: ./src/base/vc-menu/commonPropsType.js
var commonPropsType = __webpack_require__(101);

// EXTERNAL MODULE: ./src/base/config-provider/index.jsx + 1 modules
var config_provider = __webpack_require__(8);

// CONCATENATED MODULE: ./src/components/menu/index.jsx


function menu_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function menu_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { menu_ownKeys(Object(source), true).forEach(function (key) { menu_defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { menu_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function menu_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }











 // import "./style/index.scss";

var MenuMode = vue_types["a" /* default */].oneOf(["vertical", "vertical-left", "vertical-right", "horizontal", "inline"]);
var menu_menuProps = menu_objectSpread(menu_objectSpread({}, commonPropsType["a" /* default */]), {}, {
  theme: vue_types["a" /* default */].oneOf(["light", "dark"]).def("light"),
  mode: MenuMode.def("vertical"),
  selectable: vue_types["a" /* default */].bool,
  selectedKeys: vue_types["a" /* default */].arrayOf(vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].number])),
  defaultSelectedKeys: vue_types["a" /* default */].array,
  openKeys: vue_types["a" /* default */].array,
  defaultOpenKeys: vue_types["a" /* default */].array,
  openAnimation: vue_types["a" /* default */].oneOfType([vue_types["a" /* default */].string, vue_types["a" /* default */].object]),
  openTransitionName: vue_types["a" /* default */].string,
  prefixCls: vue_types["a" /* default */].string,
  multiple: vue_types["a" /* default */].bool,
  inlineIndent: vue_types["a" /* default */].number.def(22),
  inlineCollapsed: vue_types["a" /* default */].bool,
  isRootMenu: vue_types["a" /* default */].bool.def(true),
  focusable: vue_types["a" /* default */].bool.def(false)
});
var Menu = {
  name: "MegMenu",
  props: menu_menuProps,
  Divider: menu_objectSpread(menu_objectSpread({}, vc_menu["a" /* Divider */]), {}, {
    name: "MegMenuDivider"
  }),
  Item: menu_objectSpread(menu_objectSpread({}, MenuItem), {}, {
    name: "MegMenuItem"
  }),
  SubMenu: menu_objectSpread(menu_objectSpread({}, SubMenu), {}, {
    name: "MegSubMenu"
  }),
  ItemGroup: menu_objectSpread(menu_objectSpread({}, vc_menu["c" /* ItemGroup */]), {}, {
    name: "MegMenuItemGroup"
  }),
  provide: function provide() {
    return {
      getInlineCollapsed: this.getInlineCollapsed,
      menuPropsContext: this.$props
    };
  },
  mixins: [BaseMixin["a" /* default */]],
  inject: {
    layoutSiderContext: {
      default: function _default() {
        return {};
      }
    },
    configProvider: {
      default: function _default() {
        return config_provider["ConfigConsumerProps"];
      }
    }
  },
  model: {
    prop: "selectedKeys",
    event: "selectChange"
  },
  updated: function updated() {
    this.propsUpdating = false;
    this.$nextTick(function () {
      this.$emit("selectedKeysChange", Object.assign({}, this.info, {
        keyPath: this.selectedKeys
      }));
    });
  },
  // beforeDestroy() {
  //   raf.cancel(this.mountRafId);
  // },
  watch: {
    mode: function mode(val, oldVal) {
      if (oldVal === "inline" && val !== "inline") {
        this.switchingModeFromInline = true;
      }
    },
    openKeys: function openKeys(val) {
      this.setState({
        sOpenKeys: val
      });
    },
    inlineCollapsed: function inlineCollapsed(val) {
      this.collapsedChange(val);
    },
    "layoutSiderContext.sCollapsed": function layoutSiderContextSCollapsed(val) {
      this.collapsedChange(val);
    }
  },
  data: function data() {
    var props = Object(props_util["getOptionProps"])(this);
    Object(warning["a" /* default */])(!("inlineCollapsed" in props && props.mode !== "inline"), "Menu", "`inlineCollapsed` should only be used when Menu's `mode` is inline.");
    this.switchingModeFromInline = false;
    this.leaveAnimationExecutedWhenInlineCollapsed = false;
    this.inlineOpenKeys = [];
    var sOpenKeys;

    if ("openKeys" in props) {
      sOpenKeys = props.openKeys;
    } else if ("defaultOpenKeys" in props) {
      sOpenKeys = props.defaultOpenKeys;
    }

    return {
      sOpenKeys: sOpenKeys,
      info: null
    };
  },
  methods: {
    collapsedChange: function collapsedChange(val) {
      if (this.propsUpdating) {
        return;
      }

      this.propsUpdating = true;

      if (!Object(props_util["hasProp"])(this, "openKeys")) {
        if (val) {
          this.switchingModeFromInline = true;
          this.inlineOpenKeys = this.sOpenKeys;
          this.setState({
            sOpenKeys: []
          });
        } else {
          this.setState({
            sOpenKeys: this.inlineOpenKeys
          });
          this.inlineOpenKeys = [];
        }
      } else if (val) {
        // 缩起时，openKeys置为空的动画会闪动，react可以通过是否传递openKeys避免闪动，vue不是很方便动态传递openKeys
        this.switchingModeFromInline = true;
      }
    },
    restoreModeVerticalFromInline: function restoreModeVerticalFromInline() {
      if (this.switchingModeFromInline) {
        this.switchingModeFromInline = false;
        this.$forceUpdate();
      }
    },
    onUpdateSelectedKeys: function onUpdateSelectedKeys(e) {
      if (this.info && this.info.key && this.info.key !== e.key || this.info == null) {
        this.info = e;
      }
    },
    // Restore vertical mode when menu is collapsed responsively when mounted
    handleMouseEnter: function handleMouseEnter(e) {
      this.restoreModeVerticalFromInline();
      this.$emit("mouseenter", e);
    },
    handleTransitionEnd: function handleTransitionEnd(e) {
      // when inlineCollapsed menu width animation finished
      var widthCollapsed = e.propertyName === "width" && e.target === e.currentTarget; // Fix SVGElement e.target.className.indexOf is not a function

      var className = e.target.className; // SVGAnimatedString.animVal should be identical to SVGAnimatedString.baseVal, unless during an animation.

      var classNameValue = Object.prototype.toString.call(className) === "[object SVGAnimatedString]" ? className.animVal : className;
      var iconScaled = e.propertyName === "font-size" && classNameValue.indexOf("anticon") >= 0;

      if (widthCollapsed || iconScaled) {
        this.restoreModeVerticalFromInline();
      }
    },
    handleClick: function handleClick(e) {
      this.handleOpenChange([]);
      this.$emit("click", e);
    },
    handleSelect: function handleSelect(info) {
      this.$emit("select", info);
      this.$emit("selectChange", info.selectedKeys);
    },
    handleDeselect: function handleDeselect(info) {
      this.$emit("deselect", info);
      this.$emit("selectChange", info.selectedKeys);
    },
    handleOpenChange: function handleOpenChange(openKeys) {
      this.setOpenKeys(openKeys);
      this.$emit("openChange", openKeys);
      this.$emit("update:openKeys", openKeys);
    },
    setOpenKeys: function setOpenKeys(openKeys) {
      if (!Object(props_util["hasProp"])(this, "openKeys")) {
        this.setState({
          sOpenKeys: openKeys
        });
      }
    },
    getRealMenuMode: function getRealMenuMode() {
      var inlineCollapsed = this.getInlineCollapsed();

      if (this.switchingModeFromInline && inlineCollapsed) {
        return "inline";
      }

      var mode = this.$props.mode;
      return inlineCollapsed ? "vertical" : mode;
    },
    getInlineCollapsed: function getInlineCollapsed() {
      var inlineCollapsed = this.$props.inlineCollapsed;

      if (this.layoutSiderContext.sCollapsed !== undefined) {
        return this.layoutSiderContext.sCollapsed;
      }

      return inlineCollapsed;
    },
    getMenuOpenAnimation: function getMenuOpenAnimation(menuMode) {
      var _this$$props = this.$props,
          openAnimation = _this$$props.openAnimation,
          openTransitionName = _this$$props.openTransitionName;
      var menuOpenAnimation = openAnimation || openTransitionName;

      if (openAnimation === undefined && openTransitionName === undefined) {
        if (menuMode === "horizontal") {
          menuOpenAnimation = "slide-up";
        } else if (menuMode === "inline") {
          menuOpenAnimation = {
            on: utils_openAnimation["a" /* default */]
          };
        } else {
          // When mode switch from inline
          // submenu should hide without animation
          if (this.switchingModeFromInline) {
            menuOpenAnimation = "";
            this.switchingModeFromInline = false;
          } else {
            menuOpenAnimation = "zoom-big";
          }
        }
      }

      return menuOpenAnimation;
    }
  },
  render: function render() {
    var _menuClassName,
        _this = this;

    var h = arguments[0];
    var layoutSiderContext = this.layoutSiderContext,
        $slots = this.$slots;
    var collapsedWidth = layoutSiderContext.collapsedWidth;
    var getContextPopupContainer = this.configProvider.getPopupContainer;
    var props = Object(props_util["getOptionProps"])(this);
    var customizePrefixCls = props.prefixCls,
        theme = props.theme,
        getPopupContainer = props.getPopupContainer;
    var getPrefixCls = this.configProvider.getPrefixCls;
    var prefixCls = getPrefixCls("menu", customizePrefixCls);
    var menuMode = this.getRealMenuMode();
    var menuOpenAnimation = this.getMenuOpenAnimation(menuMode);
    var menuClassName = (_menuClassName = {}, menu_defineProperty(_menuClassName, "".concat(prefixCls, "-").concat(theme), true), menu_defineProperty(_menuClassName, "".concat(prefixCls, "-inline-collapsed"), this.getInlineCollapsed()), _menuClassName);
    var menuProps = {
      props: menu_objectSpread(menu_objectSpread({}, Object(es["a" /* default */])(props, ["inlineCollapsed"])), {}, {
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        openKeys: this.sOpenKeys,
        mode: menuMode,
        prefixCls: prefixCls
      }),
      on: menu_objectSpread(menu_objectSpread({}, Object(props_util["getListeners"])(this)), {}, {
        select: this.handleSelect,
        deselect: this.handleDeselect,
        openChange: this.handleOpenChange,
        mouseenter: this.handleMouseEnter,
        updateSelectedKeys: this.onUpdateSelectedKeys
      }),
      nativeOn: {
        transitionend: this.handleTransitionEnd
      }
    };

    if (!Object(props_util["hasProp"])(this, "selectedKeys")) {
      delete menuProps.props.selectedKeys;
    }

    if (menuMode !== "inline") {
      // closing vertical popup submenu after click it
      menuProps.on.click = this.handleClick;
      menuProps.props.openTransitionName = menuOpenAnimation;
    } else {
      menuProps.on.click = function (e) {
        _this.$emit("click", e);
      };

      menuProps.props.openAnimation = menuOpenAnimation;
    } // https://github.com/ant-design/ant-design/issues/8587


    var hideMenu = this.getInlineCollapsed() && (collapsedWidth === 0 || collapsedWidth === "0" || collapsedWidth === "0px");
    this.$emit('inlineCollapsedChange', this.getInlineCollapsed());

    if (hideMenu) {
      menuProps.props.openKeys = [];
    }

    return h(vc_menu["e" /* default */], babel_helper_vue_jsx_merge_props_default()([menuProps, {
      "class": menuClassName
    }]), [$slots.default]);
  }
};

Menu.install = function (Vue) {
  Vue.component(Menu.name, Menu);
  Vue.component(Menu.Item.name, Menu.Item);
  Vue.component(Menu.SubMenu.name, Menu.SubMenu);
  Vue.component(Menu.Divider.name, Menu.Divider);
  Vue.component(Menu.ItemGroup.name, Menu.ItemGroup);
};

/* harmony default export */ var menu = __webpack_exports__["default"] = (Menu);

/***/ })

}]);